// JS file for ColumnistItem
